var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateInfrastructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.41,34.59l.69-5.36c.38-2.95-1.73-5.67-4.67-6.05l-16.09-2.06c-2.95-.38-5.67,1.73-6.05,4.67l-4.81,37.54c-.38,2.95,1.73,5.67,4.67,6.05l42.9,5.5c2.95,.38,5.67-1.73,6.05-4.67l3.44-26.81c.38-2.95-1.73-5.67-4.67-6.05l-21.45-2.75Zm-9.49,31.49l-16.09-2.06,.69-5.36,16.09,2.06-.69,5.36Zm1.38-10.72l-16.09-2.06,.69-5.36,16.09,2.06-.69,5.36Zm1.38-10.72l-16.09-2.06,.69-5.36,16.09,2.06-.69,5.36Zm1.38-10.72l-16.09-2.06,.69-5.36,16.09,2.06-.69,5.36Zm22.69,35.61l-21.45-2.75,3.44-26.81,21.45,2.75-3.44,26.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.74,75.42c-.25,0-.5-.02-.76-.05l-42.9-5.5c-3.23-.42-5.52-3.38-5.11-6.61l4.81-37.54c.41-3.23,3.37-5.52,6.61-5.11l16.09,2.06c3.23,.42,5.52,3.38,5.11,6.61l-.62,4.87,20.95,2.69c1.56,.2,2.95,1,3.92,2.25,.97,1.25,1.39,2.8,1.19,4.36l-3.44,26.81c-.2,1.56-1,2.95-2.25,3.92-1.05,.81-2.31,1.24-3.6,1.24ZM29.64,21.58c-1.08,0-2.12,.36-2.99,1.03-1.04,.8-1.7,1.96-1.87,3.25l-4.81,37.54c-.34,2.68,1.56,5.15,4.24,5.49l42.9,5.5c1.29,.17,2.58-.19,3.62-.99,1.04-.8,1.7-1.96,1.87-3.25l3.44-26.81c.17-1.29-.19-2.58-.99-3.62s-1.96-1.7-3.25-1.87l-21.95-2.81,.75-5.86c.34-2.68-1.56-5.15-4.24-5.49l-16.09-2.06c-.21-.03-.42-.04-.63-.04Zm38.52,48.5l-22.44-2.88,3.56-27.8,22.44,2.88-3.56,27.8Zm-21.32-3.74l20.46,2.62,3.31-25.82-20.46-2.62-3.31,25.82Zm-5.49,.3l-17.08-2.19,.81-6.36,17.08,2.19-.82,6.35Zm-15.96-3.05l15.09,1.94,.56-4.37-15.1-1.94-.56,4.37Zm17.34-7.67l-17.08-2.19,.81-6.35,17.08,2.19-.81,6.35Zm-15.96-3.06l15.1,1.94,.56-4.37-15.1-1.94-.56,4.37Zm17.34-7.67l-17.08-2.19,.81-6.35,17.08,2.19-.81,6.35Zm-15.96-3.05l15.09,1.94,.56-4.37-15.09-1.94-.56,4.37Zm17.33-7.67l-17.08-2.19,.81-6.35,17.08,2.19-.81,6.35Zm-15.96-3.05l15.09,1.94,.56-4.37-15.09-1.94-.56,4.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.71,
    y: 43.97,
    width: 5.41,
    height: 10.81,
    transform: "translate(2.88 102.03) rotate(-82.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.86,53.3l-11.72-1.5,.81-6.35,11.72,1.5-.81,6.35Zm-10.6-2.37l9.73,1.25,.56-4.37-9.73-1.25-.56,4.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 55.33,
    y: 54.69,
    width: 5.41,
    height: 10.81,
    transform: "translate(-8.96 110.02) rotate(-82.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.49,64.03l-11.72-1.5,.81-6.35,11.72,1.5-.81,6.35Zm-10.6-2.37l9.73,1.25,.56-4.37-9.73-1.25-.56,4.37Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateInfrastructure);
export default __webpack_public_path__ + "static/media/illustration_empty-state-infrastructure.76ce5c788d1a84b5a477ac1edef805e5.svg";
export { ForwardRef as ReactComponent };